// 引用css
import "../scss/base.scss";
import "../scss/mobile.scss";
// 开发引用html，热更新
if (process.env.NODE_ENV === "development") {
    require("raw-loader!../indexm.html");
    require("raw-loader!../_main.html");
}

import * as service from "./service";
service.init();
import { viewPoint } from './pointUtils.js';
// 访问页面
viewPoint({ eventType: '访问页面', eventReason: 'mobile' });

import './main';
